import { AppData } from "../../types";
import { getRequestWrapper } from "../../utilities";

export type getAppByIdResponse = AppData;

export function getAppById(id: string): Promise<getAppByIdResponse> {
  return getRequestWrapper<never, getAppByIdResponse>({
    url: `${ENV_SETTINGS.API_URL}/apps/${id}`,
  });
}
